var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0077B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23438 13.0744H11.2969V24H7.23438V13.0744ZM9.26562 7.83992C7.89844 7.83992 7 8.64792 7 9.70184C7 10.7558 7.85938 11.5989 9.22656 11.5989H9.26562C10.6719 11.5989 11.5312 10.7558 11.5312 9.70184C11.5312 8.64792 10.6719 7.83992 9.26562 7.83992ZM21.1797 12.8285C19.0312 12.8285 18.0547 13.8824 17.5469 14.6553V13.0744H13.5234C13.5234 13.0744 13.5625 14.1283 13.5234 24H17.5469V17.9224C17.5469 17.5711 17.5859 17.2549 17.6641 17.009C17.9766 16.3767 18.6406 15.7092 19.7344 15.7092C21.2188 15.7092 21.8047 16.6928 21.8047 18.1683V24H25.8281V17.7468C25.8281 14.4093 23.8359 12.8285 21.1797 12.8285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter1);
export default __webpack_public_path__ + "static/media/footer1.d43fc16cb3a71bbd15286e68433c2bd0.svg";
export { ForwardRef as ReactComponent };